import _Search from './Search';

import './style/index.js';

export type { SearchProps } from './Search';
export * from './type';

export const Search = _Search;
export default Search;
